import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'admin-on-rest';
import { getToken, refreshToken } from '../authClient';

const REFERSH_INTERVAL = 30 * 60 * 1000;

let started = false;

const checkToken = () => {
  const promise = new Promise(resolve => {
    if (getToken()) {
      setTimeout(() => {
        refreshToken()
          .then(resolve)
          .catch(e => {
            console.log('refresh token error', e);
            resolve(true);
          });
      }, REFERSH_INTERVAL);
    } else {
      setTimeout(() => resolve(true), REFERSH_INTERVAL);
    }
  });
  return promise;
};

export function* startRefreshTokenWatcher() {
  if (started) {
    return;
  }
  started = true;
  while (true) {
    const token = yield checkToken();
    if (!token) {
      yield put(showNotification('Could not refresh token', 'warning'));
    }
  }
}

export function* refreshTokenSaga() {
  yield takeEvery('AOR/DECLARE_RESOURCES', startRefreshTokenWatcher);
}



// WEBPACK FOOTER //
// ./src/sagas/refreshToken.js